import React from 'react';
import { Disclaimer } from './shared/Disclaimer';
import { SocialProof } from './shared/SocialProof';
import { StockWarning } from './StockWarning';
export function Offer() {
  return <section className="py-10 border-t border-gray-200" id="offer" data-id="element-336">
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-center" data-id="element-337">
        Om du vill göra som jag gjorde
      </h2>
      <p className="mb-6 text-lg text-center" data-id="element-338">
        Jag skriver inte det här för att säga åt dig vad du ska känna. Jag
        skriver det för att du – om du känner igen dig i tystnaden mitt i en
        mening – ska veta att du inte är ensam. Och att det finns sätt att
        stödja sig själv som inte handlar om fler genvägar, utan om bättre
        förutsättningar.
      </p>
      <h3 className="text-xl sm:text-2xl font-bold mb-6 text-center" data-id="element-339">
        Specialerbjudande: prova Brainy i dag
      </h3>
      <div className="bg-white p-6 rounded-lg shadow-md my-6" data-id="element-340">
        <div className="flex flex-col md:flex-row items-center" data-id="element-341">
          <div className="md:w-2/3 mb-6 md:mb-0 md:pr-6" data-id="element-342">
            <div className="mb-4" data-id="element-343">
              <p className="text-lg text-gray-600 line-through mb-1" data-id="element-344">
                Ord. 374 kr
              </p>
              <div className="flex items-center mb-2" data-id="element-345">
                <span className="bg-orange-100 text-orange-700 font-bold py-1 px-3 rounded-full text-sm mr-3" data-id="element-346">
                  50% RABATT
                </span>
                <p className="text-3xl font-bold" data-id="element-347">NU 187 kr</p>
              </div>
              <p className="text-sm text-gray-600" data-id="element-348">Endast 6,23 kr per dag</p>
            </div>
            <StockWarning data-id="element-349" />
            <div className="mb-6" data-id="element-350">
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-3 text-sm text-center" data-id="element-351">
                <p className="font-medium" data-id="element-352">Erbjudandet gäller i 48 timmar</p>
              </div>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg mb-4 border-l-4 border-[#2e7d32]" data-id="element-353">
              <p className="text-sm mb-2" data-id="element-354">
                <span className="font-semibold" data-id="element-355">Tänk på detta:</span> Varje dag
                du väntar är en dag du fortsätter att kämpa i uppförsbacke. Det
                är en dag till av att leta efter ord, av att försöka dölja
                glömskan, av att undra om det bara blir värre härifrån.
              </p>
              <p className="text-sm" data-id="element-356">
                Vad är värdet av att känna sig klar i huvudet igen? Att slippa
                oron? Att kunna lita på sitt minne?
              </p>
            </div>
            <a href="https://track.decidely.se/click" target="_blank" rel="nofollow noopener noreferrer" className="block w-full bg-[#2e7d32] hover:bg-[#1b5e20] text-white text-center font-bold py-4 px-6 rounded-lg transition duration-300 text-lg relative overflow-hidden group" data-id="element-357">
              <span className="absolute inset-0 w-full h-full bg-white/20 skew-x-[-20deg] transform -translate-x-full group-hover:animate-shine" data-id="element-358"></span>
              <span className="relative z-10" data-id="element-359">Läs mer på Vitaliv</span>
            </a>
            <div className="mt-3 text-center" data-id="element-360">
              <p className="text-sm text-gray-600" data-id="element-361">
                Säker betalning med Kort, Klarna eller PayPal
              </p>
            </div>
          </div>
          <div className="md:w-1/3" data-id="element-362">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o5TYxf9LrszaVpLLpPBLLd/Skarmavbild_2025-09-08_kl._13.09.28.png" alt="Brainy kosttillskott från Vitaliv i grön förpackning med gröna kapslar" className="w-full h-auto rounded-lg object-contain bg-white p-2" style={{
            maxHeight: '300px'
          }} width="400" height="300" data-id="element-363" />
          </div>
        </div>
      </div>
      <div className="my-8" data-id="element-364">
        <h4 className="text-xl font-bold mb-4 text-center" data-id="element-365">
          Vad andra säger om Brainy
        </h4>
        <SocialProof data-id="element-366" />
      </div>
      <div className="bg-green-50 border border-green-200 rounded-lg p-5 my-6" data-id="element-367">
        <h4 className="text-xl font-bold mb-3 text-center text-green-800" data-id="element-368">
          VETENSKAPLIGT GENOMBROTT: 97% UPPLEVER FÖRBÄTTRING
        </h4>
        <p className="text-center mb-4" data-id="element-369">
          En nyligen genomförd studie* visar att hela 97% av deltagarna upplevde
          märkbar förbättring av minne och kognitiv funktion inom 30 dagar.
        </p>
        <p className="text-xs text-gray-500 text-center" data-id="element-370">
          *Baserat på en enkätstudie med 37 deltagare. Individuella resultat kan
          variera.
        </p>
      </div>
      <div className="mt-6 text-center" data-id="element-371">
        <Disclaimer data-id="element-372" />
      </div>
    </section>;
}